import { InitialBoundsData } from 'components/map/location/defaultMapLocation';
import { LocationPickerButton } from 'elements/minute/sidebar/sidebarComponents/complex/LocationPickerButton';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import { useState } from 'react';
import { Localization } from 'static/localization/localization';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    className?: string;
    initialBounds: InitialBoundsData;
    onChange: (data: InitialBoundsData) => void;
}

export const InitialBounds = (props: Props): JSX.Element => {
    const [initial, setInitial] = useState<InitialBoundsData>({
        topLeft: props.initialBounds.topLeft,
        bottomRight: props.initialBounds.bottomRight
    });

    useUpdateEffect(() => {
        props.onChange(initial);
    }, [initial]);

    return (
        <>
            <SidebarSectionRow title={Localization.TOP_LEFT}>
                <LocationPickerButton
                    coordinate={initial.topLeft}
                    onChange={(coordinates) => {
                        setInitial(() => ({
                            ...initial,
                            topLeft: coordinates
                        }));
                    }}
                />
            </SidebarSectionRow>
            <SidebarSectionRow title={Localization.BOTTOM_RIGHT}>
                <LocationPickerButton
                    coordinate={initial.bottomRight}
                    onChange={(coordinates) => {
                        setInitial(() => ({
                            ...initial,
                            bottomRight: coordinates
                        }));
                    }}
                />
            </SidebarSectionRow>
        </>
    );
};
